module.exports = __webpack_public_path__ + "img/occupation_forget_fr-ch.4e5d73c8.svg";